const images = require.context("../images", true)
const audios = require.context("../audios", true)

const content = {
	imageContainerClass: "bg-extended pos-1",
	images: [
		{
			src: images("./bunu_where_i_left.gif"),
			class: "image-five",
			imgdiv: "imageCover",
		},
	],
	texts: [
		{
			textDivClass: "story-text position-right-center text-center",
			textIndivData: [
				{
					textData: "कहाँ छाडेँ त?",
					textClass: "fz-6 m-0 one-line",
					timestamps: [{ start: 0 }, { start: 1.1 }, { start: 1.65 }],
				},
				{
					textData: "आफूलाई हतार भइसक्यो!",
					textClass: "fz-6 m-0 one-line",
					timestamps: [{ start: 2.9 }, { start: 3.5 }, { start: 4.05 }],
				},
			],
		},
	],
	sounds: [
		{
			url: audios("./10.ogg"),
			delay: 500,
		},
	],
}

export default content
